import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";


export const getAgreementEsignStatus = createAsyncThunk(
  "esign/getAgreementEsignStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ type: "company" });
      if (payload?.transactionId) params.append("transactionId", payload.transactionId);
      if (payload?.dealId) params.append("dealId", payload.dealId);
      const response = await axios.get(
        `/api/admin/getAgreementEsignStatus?${params.toString()}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendNdaESignRequest = createAsyncThunk(
  "esign/sendNdaESignRequest",
  async (payload) => {
    const orgId = typeof payload === "object" ? payload.orgId : payload;
    const params = new URLSearchParams({ orgId: String(orgId) });

    if (typeof payload === "object") {
      if (payload.document_id) params.append("document_id", payload.document_id);
      if (payload.docket_id) params.append("docket_id", payload.docket_id);
      if (payload.stakeholder_id) params.append("stakeholder_id", payload.stakeholder_id);
    }

    const response = await axios.get(
      `/api/admin/sendNdaESignRequest?${params.toString()}`
    );
    return response;
  }
);

export const getNdaEsignStatus = createAsyncThunk(
  "esign/getNdaEsignStatus",
  async ({ orgId, document_id, docket_id }) => {
    const response = await axios.get(
      `/api/admin/getNdaEsignStatus?orgId=${orgId}&document_id=${document_id}&docket_id=${docket_id}`
    );
    return response;
  }
);

export const sendSlaESignRequest = createAsyncThunk(
  "esign/sendSlaESignRequest",
  async (payload) => {
    const orgId = typeof payload === "object" ? payload.orgId : payload;
    const params = new URLSearchParams({ orgId: String(orgId) });

    if (typeof payload === "object") {
      if (payload.document_id) params.append("document_id", payload.document_id);
      if (payload.docket_id) params.append("docket_id", payload.docket_id);
      if (payload.stakeholder_id) params.append("stakeholder_id", payload.stakeholder_id);
    }

    const response = await axios.get(
      `/api/admin/sendSlaESignRequest?${params.toString()}`
    );
    return response;
  }
);

export const getSlaEsignStatus = createAsyncThunk(
  "esign/getSlaEsignStatus",
  async ({ orgId, document_id, docket_id }) => {
    const response = await axios.get(
      `/api/admin/getSlaEsignStatus?orgId=${orgId}&document_id=${document_id}&docket_id=${docket_id}`
    );
    return response;
  }
);

export const getEsignStatusByOrgId = createAsyncThunk(
  "esign/getEsignStatusByOrgId",
  async (orgId) => {
    const response = await axios.get(
      `/api/admin/getEsignStatusByOrgId?orgId=${orgId}`
    );
    return response;
  }
);

const EsignSlice = createSlice({
  name: "esign",
  initialState: {
    esignData: {},

    agreementData: {},
    agreementLoading: false,

    agreementSubmitLoading: false,
    agreementSubmitError: null,

    ndaAgreementData: {},
    ndaAgreementLoading: false,
    ndaAgreementError: null,

    ndaStatusLoading: false,
    ndaStatusError: null,
    ndaStatusData: {},

    slaAgreementData: {},
    slaAgreementLoading: false,
    slaAgreementError: null,

    slaStatusLoading: false,
    slaStatusError: null,
    slaStatusData: {},

    StatusData: {},
    StatusError: null,
    StatusLoading: false,

    loading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(getAgreementEsignStatus.pending, (state) => {
      state.agreementSubmitLoading = true;
      state.agreementSubmitError = null;
    });
    builder.addCase(getAgreementEsignStatus.fulfilled, (state, action) => {
      state.agreementSubmitLoading = false;
      state.agreementSubmitError = null;
    });
    builder.addCase(getAgreementEsignStatus.rejected, (state, action) => {
      state.agreementSubmitLoading = false;
      state.agreementSubmitError = action.payload;
    });

    builder.addCase(sendNdaESignRequest.pending, (state) => {
      state.ndaAgreementLoading = true;
      state.ndaAgreementError = null;
    });
    builder.addCase(sendNdaESignRequest.fulfilled, (state, action) => {
      state.ndaAgreementLoading = false;
      state.ndaAgreementError = null;
      state.ndaAgreementData = action.payload.response;
    });
    builder.addCase(sendNdaESignRequest.rejected, (state, action) => {
      state.ndaAgreementLoading = false;
      state.ndaAgreementData = {};
      state.ndaAgreementError = action.payload;
    });

    builder.addCase(getNdaEsignStatus.pending, (state) => {
      state.ndaStatusLoading = true;
      state.ndaStatusError = null;
    });
    builder.addCase(getNdaEsignStatus.fulfilled, (state, action) => {
      state.ndaStatusLoading = false;
      state.ndaStatusError = null;
      state.ndaStatusData = action.payload.response;
    });
    builder.addCase(getNdaEsignStatus.rejected, (state, action) => {
      state.ndaStatusLoading = false;
      state.ndaStatusData = {};
      state.ndaStatusError = action.payload;
    });

    builder.addCase(sendSlaESignRequest.pending, (state) => {
      state.slaAgreementLoading = true;
      state.slaAgreementError = null;
    });
    builder.addCase(sendSlaESignRequest.fulfilled, (state, action) => {
      state.slaAgreementLoading = false;
      state.slaAgreementError = null;
      state.slaAgreementData = action.payload.response;
    });
    builder.addCase(sendSlaESignRequest.rejected, (state, action) => {
      state.slaAgreementLoading = false;
      state.slaAgreementData = {};
      state.slaAgreementError = action.payload;
    });

    builder.addCase(getSlaEsignStatus.pending, (state) => {
      state.slaStatusLoading = true;
      state.slaStatusError = null;
    });
    builder.addCase(getSlaEsignStatus.fulfilled, (state, action) => {
      state.slaStatusLoading = false;
      state.slaStatusError = null;
      state.slaStatusData = action.payload.response;
    });
    builder.addCase(getSlaEsignStatus.rejected, (state, action) => {
      state.slaStatusLoading = false;
      state.slaStatusData = {};
      state.slaStatusError = action.payload;
    });

    builder.addCase(getEsignStatusByOrgId.pending, (state) => {
      state.StatusLoading = true;
      state.StatusError = null;
    });
    builder.addCase(getEsignStatusByOrgId.fulfilled, (state, action) => {
      state.StatusLoading = false;
      state.StatusError = null;
      state.StatusData = action.payload.response;
    });
    builder.addCase(getEsignStatusByOrgId.rejected, (state, action) => {
      state.StatusLoading = false;
      state.StatusData = {};
      state.StatusError = action.payload;
    });

  },
  reducers: {},
});

// eslint-disable-next-line no-empty-pattern
export const { } = EsignSlice.actions;

export default EsignSlice.reducer;
